/**
 * Dashboard
 * Re-exports the refactored component from the new modular structure
 */
import Dashboard from './dashboard/index';
export default Dashboard;
